const COMMON_CLASSNAME = "flash-ux-lib";
export {
  COMMON_CLASSNAME
};
//# sourceMappingURL=constants.js.map
